<div class="flex flex-col h-full">
  @if (isGuest) {
    <div class="w-auto mx-4 flex flex-col items-center justify-center">
    <vw-icon-svg iconUrl="/assets/images/willy/willy_busy.png" additionalClasses="w-auto h-72"></vw-icon-svg>
    <div class="flex flex-col gap-2 rounded-3xl grow p-4 mx-6 bg-grey-100 h-min relative">
      <div class="absolute -top-10 size-12 left-[10%] rotate-180 z-0 flex justify-end">
        <svg width="100%" height="100%" viewBox="0 0 100 100">
          <path d="M40 0 L100 0 L0 100 Z" fill="#F0EFEF" />
        </svg>
      </div>
      <h2 class="text-grey-700 text-lg">
        {{ "willy.guest.title" | translate }}
      </h2>
      <p class="text-grey-700 text-sm">
        {{ "willy.guest.p1" | translate }}
      </p>
      <ul class="text-sm list-disc list-inside pl-4 text-grey-700">
        <li>
          {{ "willy.guest.p2" | translate }}
        </li>
        <li>
          {{ "willy.guest.p3" | translate }}
        </li>
        <li>
          {{ "willy.guest.p4" | translate }}
        </li>
        <li>
          {{ "willy.guest.p5" | translate }}
        </li>
      </ul>
    </div>
    </div>
  }
  @if (!isGuest) {
    <vw-ai-chatbot-header (newConversation)="onNewConversation()"></vw-ai-chatbot-header>
  }
  @if (!isGuest) {
    <div #thread class="h-full overflow-y-auto px-4 py-3 flex flex-col gap-3">
      @for (m of messages; track $index) {
        @if (m.role === 'assistant') {
          <div class="flex items-end gap-2 max-w-[85%] self-start">
            <img src="/assets/images/willy/willy_hi.png" alt="Willy" class="w-9 h-9 object-contain shrink-0">
            <div class="bg-grey-100 rounded-2xl rounded-bl-md px-3 py-2 text-sm leading-6 whitespace-pre-line">{{ m.text }}</div>
          </div>
        } @else {
          <div class="self-end max-w-[85%] flex flex-col items-end gap-1">
            @if (m.photoUrls?.length) {
              <div class="flex gap-1 justify-end flex-wrap">
                @for (url of m.photoUrls; track url) {
                  <img [src]="url" class="size-16 rounded-xl object-cover" alt="">
                }
              </div>
            }
            @if (m.text) {
              <div class="bg-primary text-white rounded-2xl rounded-br-md px-3 py-2 text-sm leading-6 whitespace-pre-line">{{ m.text }}</div>
            }
          </div>
        }
      }
      @if (willyLoading) {
        <div class="flex items-end gap-2 max-w-[85%] self-start">
          <img src="/assets/images/willy/willy_busy.png" alt="Willy" class="w-9 h-9 object-contain shrink-0">
          <div class="bg-grey-100 rounded-2xl rounded-bl-md px-3 py-2 text-sm italic text-grey-700">{{ 'willy.thinking' | translate }}</div>
        </div>
      }
    </div>
  }
  @if (!isGuest) {
    <div class="bg-white shrink-0 shadow-[0px_-5px_20px_rgba(38,41,57,0.12)] py-4 relative z-[999]">
      <vw-ai-chatbot-input-message (messageSubmitted)="sendMessageToWilly($event)" (inputFocus)="onInputFocus()"
        (inputBlur)="onInputBlur()"></vw-ai-chatbot-input-message>
    </div>
  }
</div>